import React from 'react';
import { IconProps } from '.';

const SvgColoredGrowth = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill='#5AC27C'
        d='M2 5h4a6.002 6.002 0 0 1 5.917 5h.084a5.122 5.122 0 0 1 5.121-5H22a6 6 0 0 1-6 6h-3v10h-2V11H8a6 6 0 0 1-6-6Z'
      />
    </svg>
  );
};

export default SvgColoredGrowth;
